export default __webpack_public_path__ + "static/media/SOLUCIONESDISPENSADOR.7e53e529.webp";